import { render, staticRenderFns } from "./evidencia-comunicaciones-editar.vue?vue&type=template&id=227ac0bc&"
import script from "./evidencia-comunicaciones-editar.vue?vue&type=script&lang=js&"
export * from "./evidencia-comunicaciones-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports